import { MessageCircle } from "lucide-react";
import { useWhatsAppLink } from "@/lib/whatsapp";

const WhatsAppButton = () => {
  const href = useWhatsAppLink();
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 md:bottom-6 md:right-6 md:h-auto md:w-auto md:gap-2 md:rounded-full md:px-5 md:py-3"
    >
      <MessageCircle size={22} fill="white" stroke="none" />
      <span className="hidden text-sm font-medium md:inline">WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
